.control {
  border: 1px solid var(--input-border-color);
}

.control:hover {
  background-color: var(--mantine-color-primary-0);
}

.control[data-active="true"] {
  background-color: var(--mantine-color-white);
  color: var(--mantine-color-text);
  font-weight: 600;
  border: 1px solid var(--mantine-color-text);
}

.control[data-active="true"]:hover {
  background-color: var(--mantine-color-white);
}
